import React, { useState, useEffect, forwardRef } from 'react';
import { Link, useParams, useHistory } from "react-router-dom";
import { useGlobal } from 'reactn';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import DatePicker from "react-datepicker";
import { addDays } from "date-fns";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import allLocales from '@fullcalendar/core/locales-all';

import { useAuth } from 'stores/auth';
import { useApi } from 'stores/api';
import { fmtPrice } from 'stores/utils';
import Loader from 'components/Loader';
import Stepper from 'components/Stepper';
import FixedBottom from 'components/FixedBottom';

import 'swiper/swiper-bundle.min.css';

const BWBookingData = (props) => {

  const { t } = useTranslation(['wizard-bookingdata']);

  let currentLang = i18n.languages[0];
  if (currentLang === 'en') currentLang = 'en-gb';

  let { objectId } = useParams();
  let history = useHistory();
  const auth = useAuth();
  const api = useApi();

  const [masterData] = useGlobal('masterData');
  const [searchParams, setSearchParams] = useGlobal('searchParams');
  const [objectDetails, setObjectDetails] = useGlobal('objectDetails');
  const [modalProps, setModalProps] = useGlobal('modalProps');
  const [showLoader, setShowLoader] = useGlobal('showLoader');
  const [cartCount] = useGlobal('cartCount');
  const [currentTxnId] = useGlobal('currentTxnId');
  const [isSameTimePeriod] = useGlobal('isSameTimePeriod');
  const calendarRef = React.useRef();
  const [calendarView, setCalendarView] = useState('timeGridWeek');
  const [eventSourcesArr, setEventSourcesArr] = useState([]);
  const [inited, setInited] = useState(false);

  const [currentStartStr, setCurrentStartStr] = useState('');
  const [currentEndStr, setCurrentEndStr] = useState('');
  const [hasNewOffer, setHasNewOffer] = useState(false);
  const [processing, setProcessing] = useState(false);
  //const currency = objectDetails?.businessUnit?.Currency_Name;

  const maxAhead = masterData.organization.MaxBookingAhead || 365;

  const onChangeStartDate = (date) => {
    if (date < new Date()) {
      return;
    }
    var updateEnd = false;
    if (date > searchParams.endDate) {
      updateEnd = true;
    }
    if (updateEnd) {
      setSearchParams({ ...searchParams, startDate: date, endDate: new Date(date.getTime()) });
    } else {
      setSearchParams({ ...searchParams, startDate: date });
    }

    // let currentDiff = searchParams.endDate - searchParams.startDate;
    // let newDiff = searchParams.endDate - date;
    // if (newDiff <= 0) {
    //   let newEnd = new Date(date.getTime() + currentDiff);
    //   setSearchParams({ ...searchParams, startDate: date, endDate: newEnd });
    // } else {
    //   setSearchParams({ ...searchParams, startDate: date });
    // }
  }

  const onChangeEndDate = (date) => {
    var sDate = new Date(searchParams.startDate.getTime());
    sDate.setHours(0, 0, 0, 0);
    if (date < new Date() || date < sDate) {
      return;
    }
    setSearchParams({ ...searchParams, endDate: date });
    // let currentDiff = searchParams.endDate - searchParams.startDate;
    // let newDiff = date - searchParams.startDate;
    // if (newDiff <= 0) {
    //   let newStart = new Date(date.getTime() - currentDiff);
    //   let coeff = 1000 * 60 * 60;
    //   let now = new Date();
    //   let nowRounded = new Date(Math.ceil(now.getTime() / coeff) * coeff)
    //   setSearchParams({ ...searchParams, startDate: newStart < nowRounded ? nowRounded : newStart, endDate: date });
    // } else {
    //   setSearchParams({ ...searchParams, endDate: date });
    // }
  }

  const checkAndUpdateDates = (exceptions, options) => {
    if (exceptions && exceptions.length > 0) {
      const hasStartDate = exceptions.find(exc => exc.EntityName === 'RentalTransactionOffer' && exc.FieldName === 'StartDate');
      const hasEndDate = exceptions.find(exc => exc.EntityName === 'RentalTransactionOffer' && exc.FieldName === 'EndDate');
      const hasTimeUnit = exceptions.find(exc => exc.EntityName === 'RentalTransactionOffer' && exc.FieldName === 'TimeUnitQuantity');
      if (hasStartDate || hasEndDate || hasTimeUnit) {
        console.log('has updated offer');
        if (options.RentalObjectOffer && options.RentalObjectOffer.length > 0) {
          const offer = options.RentalObjectOffer[0];
          if (offer.RentalTransactionOfferSelectable && offer.RentalTransactionOfferSelectable.length > 0) {
            setHasNewOffer(true);
          }
        }
      }
    }
  }

  const showUpdatedOffers = async () => {
    setShowLoader(true);
    const { startDate, endDate } = searchParams;
    const result = await api.fetchObjectOptions({ objectId, startDate, endDate });
    if (result.objectExceptions && result.objectExceptions.length > 0) {
      checkAndUpdateDates(result.objectExceptions, result.objectOptions);
      setModalProps({ ...modalProps, showModal: true, messages: result.objectExceptions.map(ex => ex.Message) });
    }
    setObjectDetails({ ...objectDetails, objectOptions: result.objectOptions, objectExceptions: result.objectExceptions });
    goSelection({ refresh: true });
    setShowLoader(false);
  }

  const hasPrice = () => {
    return objectDetails.rentalObject.ResultPriceFrom ? true : false;
  }

  const hasOffer = () => {
    let { objectOptions } = objectDetails;
    return objectOptions &&
      objectOptions.RentalObjectOffer &&
      objectOptions.RentalObjectOffer.length > 0 &&
      objectOptions.RentalObjectOffer[0].RentalTransactionOfferSelectable &&
      objectOptions.RentalObjectOffer[0].RentalTransactionOfferSelectable.length > 0
  }

  const hasOptions = () => {
    const services = objectDetails.objectOptions.Services;
    const accessories = objectDetails.objectOptions.Accessories;
    return services.length > 0 || accessories.length > 0;
  }

  const onClickOptions = async (e) => {
    e.preventDefault();
    if (processing) return;
    setProcessing(true);
    let exactMatch = masterData.organization.SearchExact;
    let result = await api.createTxn(objectId, exactMatch);
    if (result) {
      history.push('/wizard/options/add');
    }
  }

  const onClickPersonalData = async (e) => {
    e.preventDefault();
    if (processing) return;
    setProcessing(true);
    let exactMatch = masterData.organization.SearchExact;
    let result = await api.createTxn(objectId, exactMatch);
    if (result) {
      history.push(`/wizard/personaldata`);
    }
  }

  const onClickOverview = async (e) => {
    e.preventDefault();
    if (processing) return;
    setProcessing(true);
    let exactMatch = masterData.organization.SearchExact;
    let txnId = await api.createTxn(objectId, exactMatch);
    let result = await api.createOrUpdateOrder(null, txnId);
    //let result = await api.setLesseeData(orderId);
    if (result) {
      history.push(`/wizard/overview`);
    }
  }

  const onClickCancel = async (e) => {
    e.preventDefault();
    let result = true;
    if (currentTxnId) {
      result = api.cancelTemporaryBooking();
    }
    if (result) {
      history.push(`/search`);
    }
  }

  const CustomInputStart = forwardRef(({ value, onClick }, ref) => (
    <div onClick={onClick} ref={ref} className="custom-input-date start">
      <div className="custom-input-selectedValue">{value}</div>
    </div>
  ));

  const CustomInputEnd = forwardRef(({ value, onClick }, ref) => (
    <div onClick={onClick} ref={ref} className="custom-input-date end">
      <div className="custom-input-selectedValue">{value}</div>
    </div>
  ));

  const onDatesSet = (dateInfo) => {
    console.log('---dates set----');
    let { start, end, startStr, endStr, timeZone, view } = dateInfo;
    let { type, title } = view;
    startStr = startStr.substr(0, 19);
    endStr = endStr.substr(0, 19);
    if (!(currentStartStr === startStr && currentEndStr === endStr) || hasNewOffer) {
      fetchNewEvents(startStr, endStr);
      setCurrentStartStr(startStr);
      setCurrentEndStr(endStr);
      setHasNewOffer(false);
    }
    return [];
  }

  const fetchNewEvents = async (startStr, endStr) => {
    let { startDate, endDate } = searchParams;
    const contentUPDT = await getContentUPDT(startStr, endStr);
    const updtEvents = await getUPDTEvents(contentUPDT);
    const alreadyBookedEvents = await getAlreadyBookedEvents(startStr, endStr);
    const currentEvent = [{ start: startDate, end: endDate, title: t("selection") }];
    setEventSourcesArr([
      {
        events: currentEvent,
        className: 'calendar-selection',
      },
      {
        events: updtEvents,
        className: 'calendar-updt',
      },
      {
        events: alreadyBookedEvents,
        className: 'calendar-booked',
      },
    ]);
    if (!inited) {
      goSelection();
      setInited(true);
    }
  }

  const getContentUPDT = async (startStr, endStr) => {
    return await api.getUnavailablePickupAndDropoffTimes(objectId, startStr, endStr);
  }

  const getUPDTEvents = async (contentUPDT) => {
    let updtItems = [];
    for (let outer of contentUPDT) {
      for (let inner of outer.UnavailablePickupAndDropoffInterval) {
        updtItems.push({
          start: (inner.DateFrom.substring(0, 19)),
          end: (inner.DateTo.substring(0, 19)),
        })
      }
    }
    return updtItems.map(item => {
      return {
        start: item.start,
        end: item.end,
        allDay: item.allDay,
      }
    });
  }

  const getAlreadyBookedEvents = async (startStr, endStr) => {
    let bookedEvents = [];
    let contentTAS = await api.getTimelineAllotmentWithSeasons(objectId, startStr, endStr);
    for (let outer of contentTAS) {
      if (!outer.IsBookable) {
        bookedEvents.push({
          start: (outer.TimeSlot.substring(0, 19)),
          end: (outer.TimeSlotEnd.substring(0, 19)),
        })
      }
    }
    return bookedEvents;
  }

  const goSelection = (options) => {
    let { startDate } = searchParams;
    let calendarApi = calendarRef.current?.getApi();
    if (options && options.refresh && calendarApi) {
      console.log('refreshing...');
      let view = calendarApi.view;
      let { currentStart, currentEnd } = view;
      const startStr = api.dateToISOString(currentStart);
      const endStr = api.dateToISOString(currentEnd);
      fetchNewEvents(startStr, endStr);
      setCurrentStartStr(startStr);
      setCurrentEndStr(endStr);
    }
    if (calendarApi) {
      calendarApi.gotoDate(startDate);
    }
  }

  useEffect(() => {
    const fetchObjectDetails = async () => {
      let { startDate, endDate } = searchParams;
      if (!startDate || !endDate) {
        startDate = api.roundToHour(new Date());
        endDate = new Date(startDate.getTime() + 3600000);
        setSearchParams({ ...searchParams, startDate, endDate });
      }
      await api.fetchObjectDetails({ objectId, startDate, endDate });
      setShowLoader(false);
      goSelection();
    }
    setShowLoader(true);
    setEventSourcesArr([]);
    fetchObjectDetails();
  }, []);

  useEffect(() => {
    if (objectDetails && objectDetails.objectExceptions && objectDetails.objectExceptions.length > 0) {
      checkAndUpdateDates(objectDetails.objectExceptions, objectDetails.objectOptions);
      setModalProps({ ...modalProps, showModal: true, messages: objectDetails.objectExceptions.map(ex => ex.Message) });
      goSelection();
      setShowLoader(false);
      return;
    }
  }, [objectDetails]);

  return (
    <>
      {showLoader && <Loader />}
      <Stepper activeStep="bookingdata" />
      <section className="wizard-container booking-view">
        <div className="wrapper">
          <div className="row wizard-content">
            <div className="column-12">
              <h3 className="mali-blue">{t("bookingDates")}</h3>
              <h4 className="mali-blue">{objectDetails && objectDetails.rentalObject.Name}</h4>
            </div>
          </div>
          <div className="row calendar-row">
            <div className="column-3 datepicker-container">
              <div className="search-content">
                <div className="label">{t("startdate")}</div>
                <DatePicker
                  selected={searchParams.startDate}
                  onChange={date => onChangeStartDate(date)}
                  customInput={<CustomInputStart />}
                  minDate={new Date()}
                  maxDate={addDays(new Date(), maxAhead)}
                  showTimeSelect={masterData.organization.showTime}
                  timeIntervals={masterData.organization.showTime && masterData.organization.showMinutes ? 15 : 60}
                  timeCaption="Time"
                  readOnly={cartCount && isSameTimePeriod}
                  popperClassName={masterData.organization.showTime ? 'datetime' : 'dateonly'}
                  dateFormat={masterData.organization.showTime ? "dd-MMM-yyyy HH:mm" : "dd-MMM-yyyy"}
                />
              </div>
              {/* StartDate/Time End */}

              {/* StartDate/Time Begin */}
              <div className="search-content">
                <div className="label">{t("enddate")}</div>
                <DatePicker
                  selected={searchParams.endDate}
                  onChange={date => onChangeEndDate(date)}
                  customInput={<CustomInputEnd />}
                  minDate={new Date()}
                  maxDate={addDays(new Date(), maxAhead)}
                  showTimeSelect={masterData.organization.showTime}
                  timeIntervals={masterData.organization.showTime && masterData.organization.showMinutes ? 15 : 60}
                  timeCaption="Time"
                  readOnly={cartCount && isSameTimePeriod}
                  className={masterData.organization.showTime ? 'datetime' : 'dateonly'}
                  dateFormat={masterData.organization.showTime ? "dd-MMM-yyyy HH:mm" : "dd-MMM-yyyy"}
                />
              </div>

              <div className="selectDateBtn">
                <button id="btn-apply-datetime" onClick={showUpdatedOffers}>{t("btnShow")}</button>
              </div>

              <div className="explain-text">
                <div className="label">{t("explainTitle")}</div>
                <p>{t("explainText")}</p>
              </div>

            </div>
            <div className="column-9 calendar-container">
              <div className="calendar-main">
                {objectDetails && <FullCalendar

                  customButtons={{
                    yourSelection: {
                      text: t("yourSelection"),
                      click: goSelection
                    },
                  }}

                  ref={calendarRef}
                  plugins={[dayGridPlugin, timeGridPlugin]}
                  aspectRatio={1.75}
                  locales={allLocales}
                  locale={currentLang}
                  initialView={calendarView}
                  editable={false}
                  selectable={false}
                  allDaySlot={false}
                  displayEventTime={false}
                  weekends={true}
                  nowIndicator={true}
                  datesSet={onDatesSet}
                  eventSources={eventSourcesArr}
                  firstDay={1}
                  headerToolbar={{
                    left: 'yourSelection',
                    center: 'title',
                    right: 'prev,dayGridMonth,timeGridWeek,next',
                  }}
                  slotDuration={'00:60:00'}
                  slotEventOverlap={false}
                />}
              </div>
              <div className="calendar-legend">
                <div className="label">{t("legend")}</div>
                <div className="legend-row actual-booking">
                  <div className="legend-color"></div>
                  <div className="legend-label">{t("lgdYourBooking")}</div>
                </div>
                <div className="legend-row booked">
                  <div className="legend-color"></div>
                  <div className="legend-label">{t("lgdNotAvailable")}</div>
                </div>
                <div className="legend-row pickup-drop">
                  <div className="legend-color"></div>
                  <div className="legend-label">{t("lgdStartEndTime")}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {
        objectDetails &&
        <FixedBottom>
          <div className="wrapper">
            <div className="row fixedBottom-content">
              <div className="column-8 fixedBottom-right">
                {
                  (!masterData.organization.FreeOfCharge) && objectDetails.rentalObject.ResultPriceFrom > 0 && <div className="fixedBottom-price">
                    <span className="from">{t("fromPrice")}</span>
                    <span className="amount">{objectDetails.businessUnit.Currency_Name} {fmtPrice(objectDetails.rentalObject.ResultPriceFrom)}</span>
                    <span className="duration">/ {objectDetails.rentalObject.PriceFromAllotmentTimeUnit_Name}</span>
                  </div>
                }
                {
                  hasOffer() &&
                  <div className="fixedBottom-buttons btn-forward">
                    {hasOptions() && <Link to={`/wizard/options/add`} onClick={onClickOptions} id="btn-book-object" className="book-object">
                      {t("btnOptions")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>}
                    {!hasOptions() && !auth.user && <Link to={`/wizard/personaldata`} onClick={onClickPersonalData} id="btn-book-object" className="book-object">
                      {t("btnPersonalData")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>}
                    {!hasOptions() && auth.user && <Link to={`/wizard/overview`} onClick={onClickOverview} id="btn-book-object" className="book-object">
                      {t("btnOverview")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                    </Link>}
                  </div>
                }
              </div>
              <div className="column-4 fixedBottom-left">
                <div className="fixedBottom-buttons btn-back">
                  {hasOffer() && <Link to={`/search`} onClick={onClickCancel} className="book-object">
                    <i className="fa fa-times-circle" aria-hidden="true"></i> {t("btnCancel")}
                  </Link>}
                </div>
              </div>
            </div>
          </div>
        </FixedBottom>
      }
    </>
  );
}

export default BWBookingData;